import { BaseBundle, ATTRIBUTES } from './base-bundle.js';
import '@services';
import '@modules';
import './debounce-Dg7s1ivP.js';

class MixMatch extends BaseBundle {
  #min = parseInt(this.dataset.min) || 0;

  get storageKey() {
    return `mix-match:${this.dataset.storageKey}`;
  }

  connectedCallback() {
    super.connectedCallback();

    this.select(this, ATTRIBUTES.SUMMARY.REMOVE_ALL, true).forEach((btn) => {
      btn.addEventListener('click', () => this.clearBundle());
    });
  }

  isComplete() {
    return this.getBundleCount() >= this.#min;
  }

  clearBundle() {
    super.clearBundle();

    this.select(this, ATTRIBUTES.SUMMARY.ITEM.VARIANT_ID, true).forEach((item) => item.remove());

    this.updateUI();
  }

  restoreState() {
    super.restoreState();

    this.bundle.keys().forEach((variantId) => this.buildListItem(variantId));
    this.updateUI();
  }

  updateATCButton() {
    const count = this.getBundleCount();

    this.select(this, ATTRIBUTES.SUMMARY.ATC_BUTTON, true).forEach((btn) => {
      if (this.isComplete()) {
        btn.removeAttribute('disabled');
      } else {
        btn.disabled = true;

        const minCount = this.select(btn, ATTRIBUTES.SUMMARY.MIN_COUNT);
        if (minCount) {
          minCount.textContent = this.#min - count;
        }
      }
    });
  }
}

if (!customElements.get('mix-match')) {
  customElements.define('mix-match', MixMatch);
}
